/* Auto generated file */
/* eslint-disable */
import { SVGIconSprite, type SVGIconSpriteProps } from '../icon/SVGIconSprite';

const Remove = (props: SVGIconSpriteProps) =>
    <SVGIconSprite {...props} icon="remove" />;

export { Remove, Remove as default };
